export const TXTCLI_Required = {
  "id": "TXTCLI_Required",
  "defaultMessage": "Required"
} as const;